import styled from "styled-components";

// Page container (glavni wrapper)
export const PageContainer = styled.div`
  padding: 0;
  /* min-height: 100vh; */
`;

// Search input
export const SearchInput = styled.input`
  padding: 0.75rem 1rem;
  background: #333;
  border: 1px solid #555;
  border-radius: 6px;
  color: #fff;
  font-size: 0.9rem;
  width: 300px;
  transition: all 0.2s ease;

  &::placeholder {
    color: #888;
  }

  &:focus {
    outline: none;
    border-color: #ff6b35;
    box-shadow: 0 0 0 2px rgba(255, 107, 53, 0.2);
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
`;

// Action button (za akcije u tabeli)
export const ActionButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  padding: ${({ size }) =>
    size === "small" ? "0.4rem 0.6rem" : "0.6rem 0.8rem"};
  border: none;
  border-radius: 4px;
  font-weight: 500;
  font-size: ${({ size }) => (size === "small" ? "0.75rem" : "0.85rem")};
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  min-width: ${({ size }) => (size === "small" ? "auto" : "2.5rem")};

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none !important;
  }

  &:not(:disabled):hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }

  ${({ variant }) => {
    switch (variant) {
      case "primary":
        return `
          background: #ff6b35;
          color: #fff;
          &:not(:disabled):hover {
            background: #e55a2b;
          }
        `;
      case "secondary":
        return `
          background: #666;
          color: #fff;
          &:not(:disabled):hover {
            background: #777;
          }
        `;
      case "danger":
        return `
          background: #e74c3c;
          color: #fff;
          &:not(:disabled):hover {
            background: #c0392b;
          }
        `;
      case "info":
        return `
          background: #3498db;
          color: #fff;
          &:not(:disabled):hover {
            background: #246a99;
          }
        `;
      case "success":
        return `
          background: #27ae60;
          color: #fff;
          &:not(:disabled):hover {
            background: #229954;
          }
        `;
      case "warning":
        return `
          background: #f39c12;
          color: #fff;
          &:not(:disabled):hover {
            background: #e67e22;
          }
        `;
      default:
        return `
          background: #555;
          color: #fff;
          &:not(:disabled):hover {
            background: #666;
          }
        `;
    }
  }}
`;

// POSTOJEĆI STILOVI (ažurirani i ispravni)

export const PageSection = styled.div`
  display: block;
`;

export const PageTitle = styled.h3`
  color: #ff6b35;
  font-size: 1.8rem;
  font-weight: bold;
`;

// Loading overlay
export const LoadingOverlay = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 400px;
  color: #ff6b35;

  .spinner {
    width: 40px;
    height: 40px;
    border: 3px solid #333;
    border-top: 3px solid #ff6b35;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 1rem;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  p {
    font-size: 1.1rem;
    margin: 0;
  }
`;

// Error message
export const ErrorMessage = styled.div`
  background: rgba(231, 76, 60, 0.1);
  border: 1px solid #e74c3c;
  color: #e74c3c;
  padding: 0.75rem;
  border-radius: 6px;
  margin-top: 0.5rem;
  font-size: 0.9rem;
`;

// Empty state
export const EmptyState = styled.div`
  text-align: center;
  padding: 4rem 2rem;
  color: #888;

  h3 {
    color: #ccc;
    margin-bottom: 1rem;
    font-size: 1.5rem;
  }

  p {
    font-size: 1rem;
    line-height: 1.5;
  }
`;

// Confirm modal

// CONFIRM MODAL STYLES
export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1001;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
`;

export const CloseBtn = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  color: #fff;
  border-radius: 50%;
  font-size: 1rem;
  width: 2rem;
  height: 2rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
  -webkit-backdrop-filter: blur(4px);
  background-color: rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(4px);
  transition: background 0.3s;

  &:hover {
    background: rgba(255, 255, 255, 0.15);
    color: #ff6b35;
  }
`;

export const ConfirmBox = styled.div`
  background: #1a1a1a;
  padding: 3rem 2rem;
  border-radius: 1.6rem;
  max-width: 400px;
  width: 100%;
  color: white;
  position: relative;
  text-align: center;

  h3 {
    font-family: "Poppins-SemiBold";
    font-size: 1.5rem;
    margin-bottom: 1rem;
    color: #ff6b35;
  }

  p {
    font-family: "Poppins-Medium";
    font-size: 1rem;
    margin-bottom: 2rem;
    color: #ccc;
  }
`;

export const ModalActions = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
`;

export const Cancel = styled.button`
  padding: 0.8rem 2rem;
  border-radius: 0.8rem;
  background: #333;
  color: white;
  border: none;
  font-family: "Poppins-SemiBold";
  font-size: 1rem;
  cursor: pointer;

  &:hover {
    background: #444;
  }
`;

export const Confirm = styled.button`
  padding: 0.8rem 2rem;
  border-radius: 0.8rem;
  background: #ff6b35;
  color: white;
  border: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.65rem;
  font-size: 1rem;
  font-family: "Poppins-SemiBold";
  cursor: ${(props) => (props.$disabled ? "not-allowed" : "pointer")};

  &:hover {
    background: #ff6b35;
  }
`;

// Password reset modal
export const PasswordResetModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;

  .modal-content {
    background: #2a2a2a;
    padding: 2rem;
    border-radius: 8px;
    border: 1px solid #444;
    max-width: 500px;
    width: 90%;
    text-align: center;

    h3 {
      color: #fff;
      margin-bottom: 1rem;
      font-size: 1.3rem;
    }

    p {
      color: #ccc;
      margin-bottom: 1.5rem;
      line-height: 1.5;

      strong {
        color: #ff6b35;
      }
    }

    .modal-actions {
      display: flex;
      gap: 1rem;
      justify-content: center;
    }
  }
`;

export const CenteredContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  justify-content: center;
  align-items: center;
`;

export const TableCell = styled.td`
  padding: 1rem;
  text-align: center;
  border-bottom: 1px solid #333;
  color: #cccccc;

  &:first-child {
    text-align: left;
  }

  &:last-child {
    text-align: right;
  }
`;

// Enhanced action button group
export const ActionButtonGroup = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  /* flex-wrap: wrap; */

  @media (max-width: 768px) {
    flex-direction: column;

    button {
      width: 100%;
      justify-content: center;
    }
  }
`;

// AŽURIRANI StatusBadge sa $active prop
export const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;

  ${({ $active, status }) => {
    // Ako je status prop prisutan, koristi ga
    if (status) {
      switch (status) {
        case "active":
          return `
            background: rgba(39, 174, 96, 0.2);
            color: #27ae60;
            border: 1px solid #27ae60;
          `;
        case "inactive":
          return `
            background: rgba(231, 76, 60, 0.2);
            color: #e74c3c;
            border: 1px solid #e74c3c;
          `;
        case "pending":
          return `
            background: rgba(255, 107, 53, .2);
            color: #ff6b35;
            border: 1px solid #ff6b35;
          `;
        default:
          return `
            background: rgba(149, 165, 166, 0.2);
            color: #95a5a6;
            border: 1px solid #95a5a6;
          `;
      }
    }

    // Inače koristi $active prop
    if ($active) {
      return `
        background: rgba(39, 174, 96, 0.2);
        color: #27ae60;
        border: 1px solid #27ae60;
      `;
    } else {
      return `
        background: rgba(231, 76, 60, 0.2);
        color: #e74c3c;
        border: 1px solid #e74c3c;
      `;
    }
  }}

  svg {
    font-size: 0.8rem;
  }
`;

// Enhanced button with loading states
export const Button = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none !important;
  }

  &:not(:disabled):hover {
    transform: translateY(-1px);
  }

  ${({ variant }) => {
    switch (variant) {
      case "primary":
        return `
          background: #ff6b35;
          color: #fff;
          &:not(:disabled):hover {
            background: #e55a2b;
          }
        `;
      case "secondary":
        return `
          background: #444;
          color: #fff;
          border: 1px solid #666;
          &:not(:disabled):hover {
            background: #555;
            border-color: #777;
          }
        `;
      case "danger":
        return `
          background: #e74c3c;
          color: #fff;
          &:not(:disabled):hover {
            background: #c0392b;
          }
        `;
      case "success":
        return `
          background: #27ae60;
          color: #fff;
          &:not(:disabled):hover {
            background: #229954;
          }
        `;
      default:
        return `
          background: #666;
          color: #fff;
          &:not(:disabled):hover {
            background: #777;
          }
        `;
    }
  }}
`;

// Responsive table container

export const TableContainer = styled.div`
  background: #1a1a1a;
  border-radius: 15px;
  padding: 1.5rem;

  border: 1px solid #333;
  overflow-x: auto;

  @media (max-width: 1200px) {
    font-size: 0.9rem;
  }

  @media (max-width: 768px) {
    font-size: 0.8rem;

    ${ActionButtonGroup} {
      flex-direction: column;
      gap: 0.25rem;
    }

    button {
      font-size: 0.7rem;
      padding: 0.5rem;
    }
  }
`;

// Enhanced table
export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  td {
    min-width: 10rem;
    white-space: nowrap;
  }
`;

export const TableHeader = styled.th`
  padding: 1rem;
  text-align: center;
  border-bottom: 1px solid #333;
  color: #ff6b35;
  font-weight: bold;
  background: rgba(255, 107, 53, 0.1);

  &:last-child {
    text-align: right;
  }

  &:first-child {
    text-align: left;
  }
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid #333;
  flex-wrap: wrap;
  gap: 1rem;

  & > div {
    display: flex;
    gap: 0.5rem;
    align-items: center;
  }
`;

export const PaginationInfo = styled.span`
  color: #cccccc;
  font-size: 0.9rem;
`;

export const PaginationButton = styled.button`
  background: ${(props) => (props.$active ? "#ff6b35" : "#333")};
  color: ${(props) => (props.$active ? "#ffffff" : "#cccccc")};
  border: 1px solid ${(props) => (props.$active ? "#ff6b35" : "#555")};
  padding: 0.5rem 0.8rem;
  min-width: 40px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: ${(props) => (props.$active ? "bold" : "normal")};
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover:not(:disabled) {
    background: ${(props) => (props.$active ? "#e55a2b" : "#444")};
    border-color: ${(props) => (props.$active ? "#e55a2b" : "#666")};
    color: #ffffff;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
    background: #333;
    border-color: #555;
    color: #666;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

// Search container
export const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 2rem;
  margin-top: 1rem;
  input {
    transition: all 0.2s ease;

    &:focus {
      border-color: #ff6b35;
      box-shadow: 0 0 0 2px rgba(255, 107, 53, 0.2);
    }
  }

  @media (max-width: 768px) {
    width: 100%;

    form {
      width: 100%;
      display: flex !important;
      gap: 0.5rem !important;
    }

    input {
      flex: 1;
      min-width: 0 !important;
    }
  }
`;

// Enhanced table row with loading state
export const TableRow = styled.tr`
  transition: background-color 0.2s ease;

  &:hover {
    background: rgba(255, 107, 53, 0.05);
  }

  &:nth-child(even) {
    background: rgba(255, 255, 255, 0.02);
  }

  &:nth-child(even):hover {
    background: rgba(255, 107, 53, 0.05);
  }
`;

// Enhanced page header for better mobile layout
export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* margin-bottom: 2rem; */
  flex-wrap: wrap;
  gap: 1rem;
  @media (max-width: 768px) {
    justify-content: center;
  }
`;

// Loading skeleton for table rows
export const SkeletonLoader = styled.div`
  background: linear-gradient(90deg, #333 25%, #444 50%, #333 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
  height: 1rem;
  width: ${({ width }) => width || "100%"};

  @keyframes loading {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;

// Results counter
export const ResultsInfo = styled.div`
  color: #999;
  font-size: 0.9rem;
  margin-bottom: 1rem;
  padding: 0.5rem 0;

  strong {
    color: #ff6b35;
  }
`;

// Clear search button
export const ClearButton = styled.button`
  background: transparent;
  border: 1px solid #666;
  color: #ccc;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.9rem;

  &:hover {
    background: #444;
    border-color: #777;
    color: #fff;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
